import { useMutation } from "react-query";
import { deleteCardReader } from "../../../../actions/CarrierAgreementMgmt/Security";

const useDeleteCardReader = () => {
  return useMutation(deleteCardReader);
};
export default useDeleteCardReader;
